<template>
  <div class="release-importance">
    <section class="release__importance" aria-labelledby="release-importance-title">
      <h2 id="release-importance-title">¿Por qué es importante <span>este proceso?</span></h2>
      <div class="release__feature-grid">
        <article
          v-for="feature in features"
          :key="feature.heading ?? feature.text"
          class="release__feature"
          :class="{ 'release__feature--wide': feature.wide }"
        >
          <picture>
            <source media="(max-width: 599px)" :srcset="feature.mobileIcon" />
            <img :src="feature.icon" alt="" aria-hidden="true" />
          </picture>
          <div v-if="feature.paragraphs" class="release__feature-copy">
            <strong>{{ feature.heading }}</strong>
            <p v-for="paragraph in feature.paragraphs" :key="paragraph">{{ paragraph }}{{ ' ' }}</p>
          </div>
          <p v-else v-html="feature.text" />
        </article>
      </div>
    </section>

    <section class="release__help" aria-labelledby="release-help-title">
      <div class="release__help-title">
        <picture>
          <source media="(max-width: 599px)" :srcset="helpMobileIcon" />
          <img :src="helpIcon" alt="" aria-hidden="true" />
        </picture>
        <h2 id="release-help-title">¿Cómo te ayuda <span>este proceso?</span></h2>
      </div>
      <p>
        Te brinda la seguridad jurídica necesaria para ostentarte como dueño absoluto de tu inmueble, eliminando el
        gravamen sobre tu propiedad y permitiéndote disfrutar plenamente de tu logro.
      </p>
    </section>
  </div>
</template>
<script setup lang="ts">
import validityIcon from '../../../assets/liberacion/icon-vigencia.svg'
import validityMobileIcon from '../../../assets/liberacion/icon-vigencia-mobile.svg'
import issuanceIcon from '../../../assets/liberacion/icon-emision.svg'
import issuanceMobileIcon from '../../../assets/liberacion/icon-emision-mobile.svg'
import propertyIcon from '../../../assets/liberacion/icon-patrimonio.svg'
import propertyMobileIcon from '../../../assets/liberacion/icon-patrimonio-mobile.svg'
import helpIcon from '../../../assets/liberacion/icon-ayuda.svg'
import helpMobileIcon from '../../../assets/liberacion/icon-ayuda-mobile.svg'
interface ReleaseFeature {
  icon: string
  mobileIcon: string
  wide?: boolean
  heading?: string
  paragraphs?: string[]
  text?: string
}
const features: ReleaseFeature[] = [
  {
    icon: propertyIcon,
    mobileIcon: propertyMobileIcon,
    wide: true,
    heading: 'Al adquirir un activo',
    paragraphs: [
      'Acreditar que el inmueble ya no garantiza ninguna obligación relacionada con el financiamiento otorgado. Contar con plena certeza jurídica sobre tu propiedad.',
      'Evitar contratiempos futuros en procesos de venta, donación, sucesión, nuevos créditos o cualquier acto que requiera demostrar que el inmueble se encuentra libre de gravamen.',
      'Concluir correctamente el proceso iniciado con la institución que financió tu inmueble.'
    ]
  },
  {
    icon: validityIcon,
    mobileIcon: validityMobileIcon,
    text: 'La carta de instrucciones de cancelación de hipoteca tiene una <strong>vigencia de 90 días.</strong>'
  },
  {
    icon: issuanceIcon,
    mobileIcon: issuanceMobileIcon,
    text: 'La primera expedición de la carta es gratuita y se emite en un tiempo aproximado de <strong>25 días naturales.</strong>'
  }
]
</script>
<style scoped>
.release-importance {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.release__importance {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.release__feature-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}
.release__feature {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;
  border-radius: 24px;
  background: var(--ds-grey-50);
}
.release__feature--wide {
  grid-column: 1/-1;
}
.release__feature picture,
.release__help-title picture {
  display: block;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
}
.release__feature img,
.release__help-title img {
  display: block;
  max-width: 40px;
  max-height: 40px;
}
h2 {
  margin: 0;
  color: var(--ds-purple-400);
  font-family: var(--ds-font-family-bebas);
  font-size: 40px;
  line-height: 44px;
}
h2 span {
  color: var(--ds-purple-900);
}
p {
  margin: 0;
  color: var(--ds-text-primary);
  font-size: 16px;
  line-height: 24px;
}
.release__help {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 16px;
  border-radius: 24px;
  background: var(--ds-grey-50);
}
.release__help-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.release__feature-copy {
  font-size: 16px;
  line-height: 24px;
}
.release__feature-copy strong {
  display: block;
  font-weight: 600;
}
.release__feature-copy p {
  display: inline;
}
@media (max-width: 599px) {
  .release__feature-copy p {
    display: block;
  }
  .release__feature-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 32px;
  }
  .release__help {
    gap: 8px;
  }
}
</style>
